import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import styles from "./App.module.css";
import AppHeader from "./layout/Header/AppHeader";
import AppNav from "containers/AppNavContainer";
import Home from "./containers/home";
import QuestionaireViewContainer from "./containers/questionaire/QuestionaireViewContainer";
import LoginContainer from "containers/auth/LoginContainer";
import LogoutContainer from "containers/auth/LogoutContainer";
import CallbackContainer from "containers/auth/CallbackContainer";
import ProtectedRoute from "containers/auth/ProtectedRouteContainer";
import Summary from "./containers/summary/summaryContainer";
import MessageTrayContainer from "containers/MessageTray";
import SoleraLoaderContainer from "containers/UI/Loader/SoleraLoaderContainer";
import ErrorView from "components/ErrorView";
import ChangePasswordContainer from "containers/changePassword/changePasswordContainer";
import ChangeRoleContainer from "containers/changeRole/changeRoleContainer";
import BasicUsageContainer from "containers/reports/BasicUsageContainer"
import AuthRequired from "components/Auth/AuthRequired";
import FeesPDF from "components/FeesPDF/FeesPDF";
import PendoContainer from "components/Pendo/PendoContainer";
import FeePreferences from "components/FeePreferences";
import FeatureRenderer from "components/Feature/RendererContainer";
import { Reporting, Dashboard } from "components/Analytics";
import NotificationsContainer from "components/Notifications/NotificationsContainer";
import AutomaticInactivityLogout from "./components/AutomaticInactivityLogout";
import GlobalDataLoader from "./components/GlobalDataLoader";

const withFeature = (Component, feature) => props => (
  <FeatureRenderer feature={feature}>
    {value => (!!value ? <Component {...props} /> : null)}
  </FeatureRenderer>
);

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      trayIsOpen: true
    };
    this.triggerTray = this.triggerTray.bind(this);
  }

  triggerTray() {
    this.setState(prevState => ({
      trayIsOpen: !prevState.trayIsOpen
    }));
  }

  render() {
    const mainClass = this.state.trayIsOpen ? styles.open : styles.closed;

    return (
      <ErrorView>
        <SoleraLoaderContainer />
        <PendoContainer />

        <AppHeader title="Settlement Fees" onTrayTrigger={this.triggerTray} />

        <div className={styles.content}>
          <AuthRequired>
            <AppNav />
            <GlobalDataLoader />
          </AuthRequired>

          <main className={`${styles.main} ${mainClass}`}>
            <ErrorView>
              <MessageTrayContainer />

              <Switch>
                <Route path="/login" exact component={LoginContainer} />
                <ProtectedRoute path="/" exact component={Home} />
                <ProtectedRoute
                  path="/questionnaire"
                  exact
                  component={QuestionaireViewContainer}
                />
                <ProtectedRoute path="/Summary" exact component={Summary} />
                <ProtectedRoute
                  path="/logout"
                  exact
                  component={LogoutContainer}
                />
                <Route
                  path="/signin-oidc"
                  exact
                  component={CallbackContainer}
                />
                <ProtectedRoute
                  path="/report/:workItemId"
                  exact
                  component={FeesPDF}
                />
                <ProtectedRoute
                  path="/change-password"
                  exact
                  component={ChangePasswordContainer}
                />
                <ProtectedRoute
                  path="/change-role"
                  exact
                  render={withFeature(ChangeRoleContainer, "GhostingUser")}
                />
                <ProtectedRoute
                  path="/preferences"
                  exact
                  render={withFeature(FeePreferences, "FeesPreferences")}
                />
                <ProtectedRoute
                  exact
                  path="/analytics/basicusage"
                  render={withFeature(BasicUsageContainer, "Analytics")}
                />
                <ProtectedRoute
                  exact
                  path="/analytics/reporting"
                  render={withFeature(Reporting, "Analytics")}
                />
                <ProtectedRoute
                  exact
                  path="/analytics/dashboard"
                  render={withFeature(Dashboard, "Analytics")}
                />
                <ProtectedRoute
                  exact
                  path="/notifications"
                  render={withFeature(NotificationsContainer, "Notifications")}
                />
                <Redirect to="/" />
              </Switch>
            </ErrorView>
          </main>
        </div>

        <AutomaticInactivityLogout />
      </ErrorView>
    );
  }
}

export default App;
